export const languages = {
    fr: 'fr',
    nl: 'nl',
};
